import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Nav({ currency, setCurrency, rates }) {
  const codes = Object.keys(rates || {});
  const location = useLocation();
  const navigate = useNavigate();
  const onHome = location.pathname === "/";

  const goToSection = (id) => {
    if (onHome) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <header
      data-testid="site-nav"
      className="sticky top-0 z-40 bg-[#FAF9F6]/80 backdrop-blur-md border-b border-[#E5E0D8]"
    >
      <div className="oak-container flex items-center justify-between h-16 md:h-20">
        <Link
          to="/"
          data-testid="brand-logo"
          className="flex items-center gap-2 font-heading font-extrabold text-lg md:text-xl text-[#1A3622]"
        >
          <span className="inline-block w-2.5 h-2.5 rounded-full bg-[#C17F59]" aria-hidden />
          Oakbridg
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-[#1C211E]">
          <button onClick={() => goToSection("pricing")} data-testid="nav-pricing" className="oak-link">
            Pricing
          </button>
          <button onClick={() => goToSection("calculator")} data-testid="nav-calculator" className="oak-link">
            Calculator
          </button>
          <Link to="/projects" data-testid="nav-projects" className="oak-link">
            Projects
          </Link>
          <button onClick={() => goToSection("process")} data-testid="nav-process" className="oak-link">
            How it works
          </button>
          <button onClick={() => goToSection("faq")} data-testid="nav-faq" className="oak-link">
            FAQ
          </button>
        </nav>

        <div className="flex items-center gap-3">
          <Select value={currency} onValueChange={setCurrency}>
            <SelectTrigger
              data-testid="currency-toggle"
              className="h-9 w-[88px] rounded-full border-[#E5E0D8] bg-white text-[#1C211E]"
              aria-label="Select currency"
            >
              <SelectValue />
            </SelectTrigger>
            <SelectContent data-testid="currency-options">
              {codes.map((c) => (
                <SelectItem key={c} value={c} data-testid={`currency-option-${c}`}>
                  {c}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <button
            onClick={() => goToSection("inquiry")}
            data-testid="nav-cta"
            className="hidden sm:inline-flex items-center justify-center rounded-full bg-[#1A3622] px-5 h-9 text-sm font-medium text-white transition-all hover:-translate-y-0.5 hover:shadow-lg hover:bg-[#122618]"
          >
            Start a project
          </button>
        </div>
      </div>
    </header>
  );
}
